module.exports = __webpack_public_path__ + "img/star.36d2cbe6.svg";